import buildPageComponents from '../buildPageComponents';

import PageLayout from './PageLayout';
import SEOPageLayout from './SEOPageLayout';

import type { Props } from '../buildPageComponents';

const PageContent = (props: Props) => {
  const { enableSEOVariantHotelsDetailsPage } = props.userContext;
  const components = buildPageComponents(
    props,
    enableSEOVariantHotelsDetailsPage,
  );
  if (enableSEOVariantHotelsDetailsPage) {
    return <SEOPageLayout components={components} />;
  }
  return <PageLayout components={components} />;
};

export default PageContent;
